import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useState, useCallback, useEffect, useRef } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import PhoneInputComponent from "react-phone-input-2";
import { componentStyles } from "./phone-input.scss";
import { commonInputStyles } from "../common-inputs.scss";
import { phoneInputStyles } from "./phone-input-component.scss";
import { phoneInputFloatingLabelStyles } from "./phone-input-floating-label.scss";
import classnames from "classnames";
function PhoneInputFloatingLabel(props) {
    const { inputData, errorState, value, cloudfrontViewerCountry, id, translate, invalid, errorLabelId } = props;
    const { inputName, isRequired, placeholder } = inputData;
    const { isValid } = errorState;
    const translatedPlaceholder = translate(placeholder) || translate("forms.fieldTitle.phoneNumber");
    const [isFocused, setIsFocused] = useState(false);
    const [hasValue, setHasValue] = useState(!!value);
    const wrapperRef = useRef(null);
    useEffect(()=>{
        var _wrapperRef_current;
        const flagButton = (_wrapperRef_current = wrapperRef.current) === null || _wrapperRef_current === void 0 ? void 0 : _wrapperRef_current.querySelector(".selected-flag");
        if (flagButton) {
            const handleFlagKeyDown = (e)=>{
                if (e.key === " " || e.code === "Space") {
                    e.preventDefault();
                    e.target.click();
                }
            };
            flagButton.addEventListener("keydown", handleFlagKeyDown);
            return ()=>flagButton.removeEventListener("keydown", handleFlagKeyDown);
        }
    }, []);
    const handleFocus = useCallback(()=>{
        setIsFocused(true);
    }, []);
    const handleBlur = useCallback(()=>{
        const { onInputBlur, value: currentValue, inputData: data } = props;
        setIsFocused(false);
        setHasValue(!!currentValue);
        if (onInputBlur) {
            onInputBlur({
                target: {
                    name: data.inputName,
                    value: currentValue
                }
            });
        }
    }, [
        props
    ]);
    const handleChange = useCallback((phone)=>{
        const { onInputChange, inputData: data } = props;
        setHasValue(!!phone);
        if (onInputChange) {
            onInputChange({
                target: {
                    name: data.inputName,
                    value: phone
                }
            });
        }
    }, [
        props
    ]);
    const showRequiredError = !isValid && isRequired;
    const defaultCountry = cloudfrontViewerCountry && cloudfrontViewerCountry.toLowerCase() || "us";
    const inputId = `${id}-input`;
    return /*#__PURE__*/ _jsxs("div", {
        ref: wrapperRef,
        className: `jsx-${phoneInputFloatingLabelStyles.__hash} jsx-${componentStyles.__hash} jsx-${commonInputStyles.__hash} jsx-${phoneInputStyles.__hash}` + " " + (classnames("floating-label-wrapper is-phone", {
            "has-value": hasValue || !!value,
            "is-focused": isFocused
        }) || ""),
        children: [
            /*#__PURE__*/ _jsx("label", {
                htmlFor: inputId,
                className: `jsx-${phoneInputFloatingLabelStyles.__hash} jsx-${componentStyles.__hash} jsx-${commonInputStyles.__hash} jsx-${phoneInputStyles.__hash}` + " " + "visually-hidden",
                children: translatedPlaceholder
            }),
            /*#__PURE__*/ _jsx("div", {
                id: id,
                className: `jsx-${phoneInputFloatingLabelStyles.__hash} jsx-${componentStyles.__hash} jsx-${commonInputStyles.__hash} jsx-${phoneInputStyles.__hash}` + " " + "hp-input hp-phone-input",
                children: /*#__PURE__*/ _jsx(PhoneInputComponent, {
                    country: defaultCountry,
                    value: value,
                    onChange: handleChange,
                    onFocus: handleFocus,
                    onBlur: handleBlur,
                    name: inputName,
                    enableSearch: true,
                    disableSearchIcon: true,
                    inputClass: showRequiredError ? "input-required" : "",
                    specialLabel: "",
                    inputProps: {
                        id: inputId,
                        "aria-label": translatedPlaceholder,
                        "aria-required": isRequired,
                        "aria-invalid": invalid,
                        "aria-describedby": errorLabelId
                    }
                })
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: phoneInputStyles.__hash,
                children: phoneInputStyles
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: commonInputStyles.__hash,
                children: commonInputStyles
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: componentStyles.__hash,
                children: componentStyles
            }),
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: phoneInputFloatingLabelStyles.__hash,
                children: phoneInputFloatingLabelStyles
            })
        ]
    });
}
export default withGenericConfig(PhoneInputFloatingLabel);
